import React from 'react';

import { colors } from './colors';

// Frozen (sticky) header + first column table styling

export const frozenTableStyling: React.CSSProperties = {
  borderCollapse: 'separate',
  borderSpacing: 0,
};

export const frozenHeaderRowStyling: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
};

export const frozenHeaderCellStyling = (
  isFrozenColumn: boolean,
): React.CSSProperties => {
  return {
    position: isFrozenColumn ? 'sticky' : undefined,
    left: isFrozenColumn ? 0 : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    zIndex: isFrozenColumn ? 2 : 1,
  };
};

export const frozenRowCellStyling = (
  isFrozenColumn: boolean,
): React.CSSProperties => {
  return {
    position: isFrozenColumn ? 'sticky' : 'relative',
    left: isFrozenColumn ? 0 : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    background: 'white',
    zIndex: isFrozenColumn ? 1 : 0,
  };
};

export const frozenMultipleHeaderCellStyling = (
  isFrozenColumn: boolean,
  frozenWidth?: number,
): React.CSSProperties => {
  const leftWidth = frozenWidth || 0;

  return {
    position: isFrozenColumn ? 'sticky' : undefined,
    left: isFrozenColumn ? leftWidth : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    zIndex: isFrozenColumn ? 2 : 1,
  };
};

export const frozenMultipleRowCellStyling = (
  isFrozenColumn: boolean,
  frozenWidth?: number,
): React.CSSProperties => {
  const leftWidth = frozenWidth || 0;

  return {
    position: isFrozenColumn ? 'sticky' : 'relative',
    left: isFrozenColumn ? leftWidth : undefined,
    borderRight: isFrozenColumn ? '2px solid' : 'none',
    borderRightColor: colors.gray[200],
    background: isFrozenColumn ? 'white' : 'none',
    zIndex: isFrozenColumn ? 1 : 0,
  };
};
